import { useReducer } from 'react';

type State = {
  paymentId?: string;
  status: 'loading' | 'success' | 'idle';
  isError: boolean;
};

type Action =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_SHOW_ERROR_COMPONENT'; payload: boolean }
  | {
      type: 'SET_SUCCESS';
      payload: { paymentId: string };
    };

const initialState: State = {
  status: 'loading',
  isError: false,
};

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, status: action.payload ? 'loading' : 'idle' };
    case 'SET_SHOW_ERROR_COMPONENT':
      return { ...state, isError: action.payload };
    case 'SET_SUCCESS':
      return {
        ...state,
        paymentId: action.payload.paymentId,
        status: 'success',
      };
    default:
      return state;
  }
}

function useCreditCardPaymentFormState() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setLoading = (isLoading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: isLoading });
  };

  const setShowErrorComponent = (show: boolean) => {
    dispatch({ type: 'SET_SHOW_ERROR_COMPONENT', payload: show });
  };

  const setSuccess = (paymentId: string) => {
    dispatch({ type: 'SET_SUCCESS', payload: { paymentId } });
  };

  return {
    state,
    setLoading,
    setShowErrorComponent,
    setSuccess,
  };
}

export { useCreditCardPaymentFormState };
